import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Tooltip from 'flarum/common/components/Tooltip';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import ItemList from 'flarum/common/utils/ItemList';
export default class PollOption extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "option", void 0);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "state", void 0);
    _defineProperty(this, "hasVoted", false);
    _defineProperty(this, "totalVotes", 0);
    _defineProperty(this, "votes", 0);
    _defineProperty(this, "voted", false);
    _defineProperty(this, "poll", void 0);
    _defineProperty(this, "canSeeVoteCount", false);
    _defineProperty(this, "answer", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.option = this.attrs.option;
    this.name = this.attrs.name;
    this.state = this.attrs.state;
    this.poll = this.state.poll;

    // isNaN(null) is false, so we have to check type directly now that API always returns the field
    this.canSeeVoteCount = typeof this.votes === 'number';
    this.answer = this.option.answer();
  }
  percent() {
    return this.totalVotes > 0 ? Math.round(this.votes / this.totalVotes * 100) : 0;
  }
  view() {
    var _this$poll$myVotes, _this$option$imageSrc;
    // following values can be changed by ui interactions, so we need to update them on every render
    this.hasVoted = this.state.hasVoted();
    this.totalVotes = this.state.overallVoteCount();
    this.votes = this.option.voteCount();
    this.voted = this.state.hasVotedFor(this.option);
    const isDisabled = this.state.loadingOptions || this.hasVoted && !this.poll.canChangeVote();
    const width = this.canSeeVoteCount ? this.percent() : Number(this.voted) / (((_this$poll$myVotes = this.poll.myVotes()) == null ? void 0 : _this$poll$myVotes.length) || 1) * 100;
    const onBarClick = e => {
      if (isDisabled || !this.state.showCheckMarks) return;
      e.preventDefault();
      this.state.changeVote(this.option, e);
    };
    const bar = m("div", {
      className: "PollBar",
      "data-selected": !!this.voted,
      style: "--poll-option-width: ".concat(width, "%"),
      onclick: onBarClick
    }, this.state.showCheckMarks && m("div", {
      className: "PollAnswer-checkbox"
    }, m("span", {
      className: "checkmark"
    })), m("div", {
      className: "PollAnswer-text"
    }, this.optionDisplayItems().toArray()), this.option.imageUrl() ? m("img", {
      className: "PollAnswer-image",
      src: this.option.imageUrl(),
      srcset: (_this$option$imageSrc = this.option.imageSrcset()) != null ? _this$option$imageSrc : undefined,
      alt: this.option.answer(),
      loading: "lazy"
    }) : null);
    return m("div", {
      className: classList('PollOption', this.hasVoted && 'PollVoted', this.option.imageUrl() && 'PollOption-hasImage'),
      "data-id": this.option.id()
    }, this.canSeeVoteCount ? m(Tooltip, {
      text: app.translator.trans('fof-polls.forum.tooltip.votes', {
        count: this.votes
      }),
      onremove: this.hideOptionTooltip
    }, bar) : bar);
  }
  hideOptionTooltip(vnode) {
    vnode.attrs.tooltipVisible = false;

    // @ts-ignore
    vnode.state.updateVisibility();
  }
  optionDisplayItems() {
    const items = new ItemList();
    items.add('answer', m("span", {
      className: "PollAnswer-text-answer",
      id: "".concat(this.name, "-").concat(this.option.id(), "-label")
    }, this.answer));
    this.voted && !this.state.showCheckMarks && items.add('check', m(Icon, {
      name: "fas fa-check-circle",
      className: "PollAnswer-check"
    }));
    this.canSeeVoteCount && items.add('percent', m("span", {
      className: classList('PollPercent', this.percent() !== 100 && 'PollPercent--option')
    }, this.percent(), "%"));
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollOption', PollOption);